import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import GridEvent from '../../components/grid/event'
import Event1 from '../../assets/image/event1.jpg'
export default class mega_semminar extends Component {
    render() {
        const image=[
            {image:Event1}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner image={image} bread_crum={['Event Management','Mega Seminar, Public Seminar, & Workshop']} title="Mega Seminar, Public Seminar, & Workshop" subtitle="We handle your awarding ceremony, top management seminars, public seminars, mega seminar, and workshops. We also manage all logistics involved in making successful and professional events."/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                ”We help our clients in developing and implementing people best practices methodology that will contribute to the company’s future growth and sustainability.”
                                <br/><br/>
                                …through
                                <br/><br/>
                                People Development
                                <br/><br/>
                                Business environment is always changing rapidly. Organization needs to prepare their employees to be ready for the new challenge they will face by having an integrated people development system.
                                <br/><br/>
                                Career System
                                <br/><br/>
                                Employee needs to know their next path in the organization. It is very important to have an integrated, competency based, career development system.
                                <br/><br/>
                                Succesion Planning
                                <br/><br/>
                                To ensure effective operation, organization needs to identify the key position in the organization that have a strategic and significant impact to the organization’s success. Organization have to ensure that the key position will be always occupied by preparing a succession planning for each key position.
                                <br/><br/>
                                Talent Management
                                <br/><br/>
                                Based on employee’s performance and competency, organization can identify their talents (Star Employee). These talents are organization’s assets that have to be developed, optimised and maintained. They will be the priority candidates for promotion.
                                <br/><br/>
                                Reward System
                                <br/><br/>
                                Reward can be divided into intrinsic and extrinsic rewards. Organisation needs to identify and manage all kind of rewards to maintain employee performance and motivation.
                                <br/><br/>
                                Employee Engagement
                                <br/><br/>
                                Engaged employees are emotionally attached and committed to the organization. Therefore, they are willing to ‘go that extra mile’ and helping the organization reach its objectives and succeed.
                                <br/><br/>
                                HR Information System
                                <br/><br/>
                                Organization will fail if they ignore IT in their process. Human Resources Information System is an important part of the whole Human Resources Management.
                            </p>
                        </div>
                        <br/><br/>
                        <GridEvent/>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
